import React from 'react';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
import './style.scss';
import { Link } from 'react-router-dom';
import SelectDropdown from '../../components/common/SelectDropdown';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'antd';
import { PiFileCsv } from 'react-icons/pi';
import { HiOutlineArrowDown } from 'react-icons/hi';
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { BsTrash3 } from 'react-icons/bs';
import statusModel from '../../models/status.model';
import { FaEye } from 'react-icons/fa';
import moment from 'moment';
import methodModel from '../../methods/methods';
import { HiArrowSmUp } from 'react-icons/hi';

const Html = ({
  clear,
  sortClass,
  sorting,
  tab,
  edit,
  view,
  tabChange,
  colClick,
  ChangeRole,
  ChangeStatus,
  openModal,
  statusChange,
  pageChange,
  addCol,
  dynamicStyle = false,
  className = null,
  deleteItem,
  exportCsv,
  uTableCols,
  removeCol,
  filters,
  filter,
  handleItemCountChange,
  tableCols,
  loaging,
  data,
  types,
  exportfun,
  dragStart,
  dragEnter,
  drop,
  dargEnterIndex,
  dargIndex,
  showData,
  isAllow,
  total = { total },
}) => {
  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };
  return (
    <Layout>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">
            Plan Features
          </h3>
          <p class="text-sm font-normal text-[#525252]">
            Here you can see all about your Plan Features
          </p>
        </div>

        <div className="flex">
          {/* <button className="!px-2.5 text-[#3C3E49] text-sm font-normal py-2.5 flex items-center justify-center gap-2 bg-[#fff] rounded-lg shadow-btn hover:bg-[#F3F2F5] border border-[#D0D5DD] transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed mr-3" onClick={() => exportfun()}>
                            <PiFileCsv className="text-typo text-xl" />  Export CSV
                        </button> */}
          {isAllow('feature_add') ? (
            <Link
              className="bg-primary flex items-center gap-2 leading-10 mr-3 h-10 shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg mr-2"
              to="/features/add"
            >
              <FiPlus className="text-xl text-white" /> Add Plan Feature
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="shadow-lg w-full bg-white rounded-lg mt-6">
        <div className="flex items-center p-4 justify-end gap-2">
          {/* <SelectDropdown
                                isSingle={true}
                                id="statusDropdown"
                                displayValue="name"
                                placeholder='All Category'
                                intialValue={filters.category}
                                result={e => filter({ category: e.value })}
                                options={categories}
                            /> */}
          <SelectDropdown
            id="statusDropdown"
            displayValue="name"
            placeholder="All Status"
            intialValue={filters.status}
            result={(e) => {
              ChangeStatus(e.value);
            }}
            options={statusModel.list}
          />
          {filters.status || filters.category ? (
            <>
              <button
                className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg"
                onClick={() => clear()}
              >
                Reset
              </button>
            </>
          ) : (
            <></>
          )}
        </div>

        {tab == 'grid' ? (
          <></>
        ) : (
          <>
            <div className="w-full bg-white rounded-lg ">
              <div className="scrollbar w-full overflow-auto">
                <table class="w-full">
                  <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
                    <tr className="border-b border-[#EAECF0]">
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('name')}
                      >
                        Name
                        <span className="ml-2">{renderSortIcon('name')}</span>
                      </th>

                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('createdAt')}
                      >
                        Created At
                        <span className="ml-2">
                          {renderSortIcon('createdAt')}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('updatedAt')}
                      >
                        Last Modified
                        <span className="ml-2">
                          {renderSortIcon('updatedAt')}
                        </span>
                      </th>
                      {/* <th scope="col" className='px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  ' onClick={e => sorting('categoryName')}>Category <span className='ml-2'><HiOutlineArrowDown className="shrink-0 inline text-sm" /></span></th> */}
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loaging &&
                      data &&
                      showData().map((itm, index) => {
                        return (
                          <tr
                            // className={` ${
                            //   dargIndex == index ? 'dragStart' : ''
                            // } ${dargEnterIndex == index ? 'dragEnter' : ''}`}
                            // onDragStart={(e) => dragStart(e, index)}
                            // onDragEnter={(e) => dragEnter(e, index)}
                            // onDragEnd={(e) => drop(e)}
                            // key={index}
                            // draggable
                          >
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                            >
                                <Tooltip placement="right" title="View">
                              <h4 className='user  cursor-pointer' onClick={(e) => view(itm.id)}>
                              {methodModel?.capitalizeFirstLetter(itm.name)}
                              {/* {itm.name} */}
                              </h4>
                              </Tooltip>
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                              // onClick={(e) => view(itm.id, 'false')}
                            >
                              {moment(itm.createdAt).format('DD MMM YYYY')}
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                              // onClick={(e) => view(itm.id, 'false')}
                            >
                              {moment(itm.updatedAt).format('DD MMM YYYY')}
                            </td>
                            {/* <td className='!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]'>{itm.category ? itm.category.name : ''}</td> */}
                            <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                              {' '}
                              <div
                                className={`user_hours ${itm.status}`}
                                onClick={() => statusChange(itm)}
                              >
                                {/* <Tooltip
                                  placement="top"
                                  title={itm?.status === "active" ? "Deactive" : "Active"}
                                > */}
                                <span
                                  className={`bg-[#1c2b35] text-white text-sm w-[100px] cursor-pointer !px-3 h-[30px] flex items-center justify-center border !rounded ${
                                    itm.status === 'active'
                                      ? 'bg-[#1c2b35]'
                                      : 'bg-[#A12238] '
                                  }`}
                                >
                                  {itm.status == 'deactive'
                                    ? 'Inactive'
                                    : 'Active'}
                                </span>
                                {/* </Tooltip> */}
                              </div>
                            </td>

                            {/* dropdown */}
                            <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                              <div className="flex items-center gap-1.5">
                                {isAllow('feature_get') ? (
                                  <>
                                    <Tooltip placement="top" title="View">
                                      <a
                                        className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                        onClick={(e) => view(itm.id)}
                                      >
                                        <FaEye />
                                      </a>
                                    </Tooltip>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {isAllow('feature_edit') ? (
                                  <Tooltip placement="top" title="Edit">
                                    <a
                                      className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                      onClick={(e) => edit(itm.id)}
                                    >
                                      <FiEdit3 />
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}
                                {isAllow('feature_delete') ? (
                                  <Tooltip placement="top" title="Delete">
                                    <span
                                      className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                      onClick={() => deleteItem(itm.id)}
                                    >
                                      <BsTrash3 />
                                    </span>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </td>
                            {/* end */}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {!loaging && total == 0 ? (
          <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
        ) : (
          <></>
        )}
        {!loaging && total > 10 ? (
          <div className="paginationWrapper flex items-center justify-between mt-15">
            <span className='text-sm text-gray-600'>Show {filters.count} from {total} Features</span>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
            <select
              className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
              value={filters.count} // Current value of items per page
              onChange={(e) => handleItemCountChange(e)} // Function to handle changes
            >
              {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <></>
        )}

        {loaging ? (
          <div className="text-center py-4">
            <img src="/assets/img/loader.gif" className="pageLoader" />
          </div>
        ) : (
          <></>
        )}
      </div>
    </Layout>
  );
};

export default Html;
